module.exports = __webpack_public_path__ + "__static/site-1768578553954/img/logo_master.c8bdcd8d.svg";